import { Skeleton } from '@/shared/components/ui/skeleton';

/** Matches the calibration session workspace while its detail loads. */
export function SessionWorkspacePendingState() {
  return (
    <div className="flex min-h-svh min-w-0 flex-col bg-background" aria-busy="true">
      <header className="flex shrink-0 items-center gap-2 border-b p-3 sm:p-4">
        <Skeleton className="h-8 w-20" />
        <div className="space-y-1">
          <Skeleton className="h-4 w-40" />
          <Skeleton className="h-3 w-56" />
        </div>
      </header>
      <main className="flex min-h-0 flex-1 flex-col gap-4 overflow-y-auto p-4 sm:p-6">
        <section className="flex-1 rounded-lg border p-3">
          <div className="flex items-center justify-between gap-2">
            <Skeleton className="h-4 w-36" />
            <div className="flex gap-2">
              <Skeleton className="h-8 w-20" />
              <Skeleton className="h-8 w-24" />
            </div>
          </div>
          <div className="mt-3 space-y-2">
            <Skeleton className="h-24 w-full" />
            <Skeleton className="h-24 w-full" />
          </div>
        </section>
      </main>
    </div>
  );
}
